export enum LabelEnum {
    ISNL = 'InsharedNL',
    ISDE = 'InsharedDE',
    ISES = 'InsharedES',
}
